// Single source of truth for expense categories.
// `value` is what is stored and shown in reports; `label` is what users see in the dropdown.
export const INVITATION_CATEGORY = 'Invitation';

export const EXPENSE_CATEGORIES: { value: string; label: string }[] = [
  { value: 'Plane / Train', label: 'Plane / Train' },
  { value: 'Hotel', label: 'Hotel' },
  { value: 'Taxi / Ride', label: 'Taxi / Ride' },
  { value: 'Public Transportation', label: 'Public Transportation' },
  { value: 'Meal (own and team)', label: 'Meal (own and team)' },
  { value: INVITATION_CATEGORY, label: 'Invitation (requires guest name)' },
  { value: 'Conference / Event', label: 'Conference / Event tickets' },
  { value: 'Communication', label: 'Communication' },
  { value: 'IT', label: 'IT' },
  { value: 'Other', label: 'Other' }
];

// No longer selectable for new expenses, but still present on older ones
export const LEGACY_CATEGORIES = ['Restaurant'];

export const ALL_CATEGORY_VALUES = [...EXPENSE_CATEGORIES.map((c) => c.value), ...LEGACY_CATEGORIES];

// Categories for which no VAT is asked
export const VAT_EXCLUDED_CATEGORIES = ['Plane / Train', 'Hotel', 'Taxi / Ride', 'Public Transportation'];

// Dropdown options; keeps an existing legacy value (e.g. "Restaurant") visible when editing
export const categoryOptions = (current?: string) =>
  current && !EXPENSE_CATEGORIES.some((c) => c.value === current)
    ? [...EXPENSE_CATEGORIES, { value: current, label: current }]
    : EXPENSE_CATEGORIES;

// Guest names for invitations are stored at the end of the description
const GUEST_MARKER = ' | Guest(s): ';

export const joinGuests = (description: string, guests: string) =>
  guests.trim() ? `${description.trim()}${GUEST_MARKER}${guests.trim()}` : description;

export const splitGuests = (justification: string) => {
  const text = justification || '';
  const idx = text.lastIndexOf(GUEST_MARKER);
  return idx === -1
    ? { description: text, guests: '' }
    : { description: text.slice(0, idx), guests: text.slice(idx + GUEST_MARKER.length) };
};
